/**
 *  TV - channels plugin or system module implementation.
 *  Same interface with tv provider from embedded magcore.
 *
 *  events list
 *  antennaPower state
 *  epg:update
 *  channels:update
 *  scanning:start
 *  scanning:stop
 */

'use strict';

/* eslint quote-props: 0 */

var Emitter        = require('cjs-emitter'),
    gettextWrapper = require('mag-gettext'),

    Channel        = require('./channel.class.js'),
    storage        = require('./storage'),

    instanceList   = [],
    channelList    = [],
    types          = {},
    supportedTypes = [],

    antennaStart = false,
    firstLoad = true,

    api, eventFunction, dataMap,
    globalEvent, gettext;


function loadChannels () {
    var data = dvbManager.GetChannelList(),
        channels = [],
        number = 0,
        index;

    channelList = [];
    if ( data === '' || data === '{}' ) {
        return;
    }

    try {
        channels = JSON.parse(data).channels;
    } catch ( error ) {
        console.log(error);

        return;
    }

    for ( index = 0; index < channels.length; index++ ) {
        channels[index]['channel_number'] = parseInt(channels[index]['channel_number'], 10);
        if ( channels[index].channel_number ) {
            number = channels[index].channel_number;
        } else {
            number++;
        }
        channelList.push(new Channel({
            name: channels[index].name,
            number: number,
            id: channels[index].id,
            url: 'dvb://' + channels[index].id,
            solution: 'dvb',
            scrambled: channels[index].scrambled === 'true',
            genre: {},
            'monitoring_status': true
        }));
    }
}


function init ( config ) {
    storage.data = config.storage;
    storage.favoriteList = storage.data.getItem('favoriteList') || [];
    firstLoad = false;
}


function initData () {
    var data = dvbManager.GetChannelList(),
        powerOfTime = 60 * 2 * 1000;

    try {
        data = JSON.parse(dvbManager.GetSupportedScanTypes());
    } catch ( error ) {
        data = [];
        console.log(error);
    }

    supportedTypes = data;
    types = {};
    data.forEach(function ( item ) {
        types[item.name] = item.type;
    });

    try {
        data = JSON.parse(dvbManager.GetCurrentScanTypes());
    } catch ( error ) {
        data = [];
        console.log(error);
    }

    dataMap = data.map(function ( item ) {
        return item.name;
    });

    globalEvent = function ( event ) {
        switch ( event.code ) {
            // epg update global event
            case 42:
                instanceList.forEach(function ( item ) { item.emit('epg:update'); });
                break;
            // detected passive antenna type
            case 43:
                if ( antennaStart ) {
                    antennaStart = false;
                } else {
                    core.notify({
                        title: gettext('Detected passive antenna type'),
                        icon: 'alert',
                        type: 'warning'
                    });
                    instanceList.forEach(function ( item ) { item.emit('antennaPower', false); });
                }
                break;
        }
    };

    stbEvent.addListener('media', globalEvent);
    if ( dataMap.indexOf('DVB-T') !== -1 || dataMap.indexOf('DVB-T2') !== -1 ) {
        dvbManager.SetAntennaPower(true, 0);
        antennaStart = true;
        setTimeout(function () {
            antennaStart = false;
        }, powerOfTime);
    }
}


function changeAntennaPower ( state ) {
    if ( dataMap.indexOf('DVB-T') !== -1 ||  dataMap.indexOf('DVB-T2') !== -1  ) {
        dvbManager.SetAntennaPower(state, 0);
        instanceList.forEach(function ( item ) { item.emit('antennaPower', state); });
    }
}


function build () {
    var check,
        // add = false,
        data = {
            id: 'dvb',
            name: gettext('DVB'),
            description: gettext('Setting the digital television parameters'),
            icon: 'theme-icon-DVB',
            sections: [
                {
                    id: 'dvb',
                    name: gettext('DVB'),
                    description: gettext('Setting the digital television parameters'),
                    icon: 'theme-icon-DVB',
                    parent: 'system'
                }
            ],
            options: [],
            content: []
        },
        antenna = {
            id: 'dvbSignal',
            name: gettext('Antenna type'),
            description: gettext('Set the antenna type: active or passive'),
            icon: 'theme-icon-dvb-power-on',
            render: api.renders.toggle,
            saveImmediate: true,
            environment: {},
            prepareForRender: function ( environment, callback ) {
                callback(dvbManager.GetAntennaPower());
            },
            prepareForSave: function ( value, callback ) {
                changeAntennaPower(value);
                callback();
            },
            getter: api.getters.environment,
            saver: api.savers.environment,
            type: 'option',
            parent: 'dvb'
        };


    data.options = [
        {
            id: 'dvbType',
            name: gettext('Signal type'),
            description: gettext('Set the signal type: DVB-T, DVB-H, DVB-T2, DVB-S2'),
            icon: 'theme-icon-equalizer-3',
            render: api.renders.popupSelect,
            saveImmediate: false,
            requireDeviceReboot: true,
            environment: {
                'dvb_type': ''
            },
            prepareForRender: function ( environment, callback ) {
                var opt = [],
                    key;

                console.log(environment['dvb_type']);
                if ( environment['dvb_type'] ) {
                    check = environment['dvb_type'];
                } else {
                    check = dataMap[0];
                }

                console.log(check);
                for ( key in types ) {
                    opt.push({
                        name: key,
                        value: types[key],
                        selected: types[key] === check
                    });
                }

                callback(opt);
            },
            prepareForSave: function ( value, callback ) {
                this.environment['dvb_type'] = value;
                // if ( !add && ( value === 'DVB-T' || value === 'DVB-T2' ) ) {
                //     api.options.add([antenna]);
                //     add = true;
                // } else {
                //     if ( add ) {
                //         api.options.remove([antenna]);
                //         add = false;
                //     }
                // }
                // this.requireDeviceReboot = dataMap.indexOf(value) === -1;
                callback();
            },
            getter: api.getters.environment,
            saver: api.savers.environment,
            type: 'option',
            parent: 'dvb'
        }
    ];

    if ( dataMap.indexOf('DVB-T') !== -1 ||  dataMap.indexOf('DVB-T2') !== -1  ) {
        data.options.push(antenna);
        // add = true;
    }

    return data;
}


function Provider () {
    var self = this;

    Emitter.call(this);

    this.types = {
        get supported () {
            return supportedTypes;
        },
        get current () {
            var data;

            try {
                data = JSON.parse(dvbManager.GetCurrentScanTypes());
            } catch ( error ) {
                data = [];
                console.log(error);
            }

            if ( data.length === 0 ) {
                data = [{name: 'Null', type: null}];
            }

            return data;
        }
    };

    this.scanOptions = {
        get more () {
            return self.types.current.types === types['DVB-C'];
        }
    };
}


Provider.prototype = Object.create(Emitter.prototype);
Provider.prototype.constructor = Provider;


Object.defineProperty(Provider.prototype, 'antennaPower', {
    get: function () {
        return dvbManager.GetAntennaPower();
    },
    set: function ( enable ) {
        if ( dataMap.indexOf('DVB-T') !== -1 || dataMap.indexOf('DVB-T2') !== -1 ) {
            dvbManager.SetAntennaPower(enable, 0);
            instanceList.forEach(function ( item ) {
                item.emit('antennaPower', enable);
            });
        }
    }
});


/**
 * Get channel list.
 *
 * @param {Object} [config] - filters configuration
 * @param {Function} callback - result handler
 */
Provider.prototype.getChannels = function ( config, callback ) {
    var result = channelList,
        regExp;

    config = config || {};
    if ( config.favorite ) {
        result = result.filter(function ( channel ) {
            return !!channel.favorite;
        });
    }

    if ( config.byName ) {
        result = result.sort(function ( ai, bi ) {
            return ai.name > bi.name ? 1 : -1;
        });
    } else {
        result = result.sort(function ( ai, bi ) {
            return ai.number > bi.number ? 1 : -1;
        });
    }

    if ( config.search ) {
        regExp = new RegExp(config.search, 'i');
        result = result.filter(function ( channel ) {
            var match = channel.name.match(regExp);

            return match && match.length;
        });
    }

    callback(false, result);
};


Provider.prototype.updateChannelsList = function ( callback ) {
    loadChannels();
    this.getChannels(null, callback);
};


Provider.prototype.getLastChannelId = function ( callback ) {
    callback(false, storage.data.getItem('lastChannel'));
};


Provider.prototype.getCurrentChannelsEpg = function ( channels, callback ) {
    var map = {};

    channels.forEach(function ( channel ) { map[channel.id] = channel.getEPGBrief(); });
    callback(false, map);
};


Provider.prototype.getChannelsEpg = function ( config, callback ) {
    var map = {},
        channels;

    config = config || {};

    channels = config.channels || [];


    if ( !config.from && !config.to ) {
        channels.forEach(function ( channel ) { map[channel.id] = channel.getEPGBrief(); });
        callback(false, map);
    } else {
        config.from = Math.round(config.from / 1000) || '';
        config.to  = Math.round(config.to / 1000) || '';
        channels.forEach(function ( channel ) { map[channel.id] = channel.getEpg(config); });
        callback(false, map);
    }
};


function autoScan ( config ) {
    config.input = config.input || 0;
    config.callbacks = config.callbacks || {};
    if ( config.type === types['DVB-C'] ) {
        dvbManager.SetScanParams(JSON.stringify({
            type: config.type,
            symRate: config.symRate,
            modulation: config.modulation,
            scanMode: 0,
            networkId: 0
        }));
    }
    dvbManager.StopChannelScan();

    eventFunction = function ( event ) {
        switch ( event.code ) {
            case 40:
                if ( event.info.state && event.info.state === 'finished' ) {
                    stbEvent.removeListener('media', eventFunction);
                    eventFunction = null;
                    if ( config.callbacks.onEnd ) {
                        config.callbacks.onEnd(event.info);
                    }
                    loadChannels();
                    instanceList.forEach(function ( item ) { item.emit('scanning:end'); });
                    instanceList.forEach(function ( item ) { item.emit('channels:update'); });
                } else if ( config.callbacks.onProgress ) {
                    config.callbacks.onProgress(event.info);
                }
                break;
            case 41:
                if ( config.callbacks.onFound ) {
                    config.callbacks.onFound(event.info);
                }
                break;
        }
    };
    stbEvent.addListener('media', eventFunction);
    dvbManager.StartChannelScan(config.type);

    instanceList.forEach(function ( item ) { item.emit('scanning:start'); });

    return true;
}


/**
 * Start auto scanning.
 *
 * @param {Object} config - scan configuration
 * @param {string} config.type - DVB type
 * @param {Object} config.callbacks - callback functions on event
 * @param {Function} config.callbacks.onProgress - progress callback function
 * @param {Function} config.callbacks.onFound - channel found callback function
 * @param {Function} config.callbacks.onEnd - channel scan was ended callback function
 * @param {number} [config.symRate] - symbol rate only for DVB-C
 * @param {number} [config.modulation] - modulation only for DVB-C
 * @param {number} [config.input] - input index default 0
 *
 * @return {boolean} scanning start
 */
Provider.prototype.startAutoScan = function ( config ) {
    if ( eventFunction ) {
        return false;
    }
    dvbManager.ClearChannelList();
    channelList = [];

    return autoScan(config);
};


function manualScan ( config ) {
    config.input = config.input || 0;
    config.callbacks = config.callbacks || {};
    dvbManager.StopChannelScan();

    eventFunction = function ( event ) {
        switch ( event.code ) {
            case 40:
                if ( event.info.state && event.info.state === 'finished' ) {
                    stbEvent.removeListener('media', eventFunction);
                    eventFunction = null;

                    if ( config.callbacks.onEnd ) {
                        config.callbacks.onEnd(event.info);
                    }

                    loadChannels();
                    instanceList.forEach(function ( item ) {
                        item.emit('scanning:end');
                    });
                    instanceList.forEach(function ( item ) {
                        item.emit('channels:update');
                    });
                } else if ( config.callbacks.onProgress ) {
                    config.callbacks.onProgress(event.info);
                }
                break;
            case 41:
                if ( config.callbacks.onFound ) {
                    config.callbacks.onFound(event.info);
                }
                break;
        }
    };
    stbEvent.addListener('media', eventFunction);

    if ( config.type === types['DVB-C'] ) {
        config.netId = config.netId || 0;
        dvbManager.SetScanParams(JSON.stringify({
            type: config.type,
            symRate: config.symRate,
            modulation: config.modulation,
            scanMode: 2,
            frequency: config.frequency,
            networkId: config.netId
        }));
        dvbManager.StartChannelScan(config.type);
    } else {
        dvbManager.StartChannelScanManual(config.frequency, config.frequencyEnd, config.type, config.band ? config.band : 8, 1000);
    }
}


/**
 * Start manual scanning.
 *
 * @param {Object} config - scan configuration
 * @param {string} config.type - DVB type
 * @param {Object} config.callbacks - callback functions on event
 * @param {Function} config.callbacks.onProgress - progress callback function
 * @param {Function} config.callbacks.onFound - channel found callback function
 * @param {Function} config.callbacks.onEnd - channel scan was ended callback function
 * @param {number} [config.symRate] - symbol rate only for DVB-C
 * @param {number} [config.modulation] - modulation only for DVB-C
 * @param {number} [config.input] - input index default 0
 * @param {number} [config.netId] - Network ID only for DVB-C
 * @param {number} config.frequency - frequency start ( or frequency only for DVB-C )
 * @param {number} [config.frequencyEnd] - frequency end not supported for DVB-C
 * @param {number} [config.band] - bandwidth
 *
 * @return {boolean} scanning start
 */
Provider.prototype.startManualScan = function ( config ) {
    if ( eventFunction ) {
        return false;
    }
    dvbManager.ClearChannelList();
    channelList = [];

    return manualScan(config);
};


/**
 * Remove all channels.
 */
Provider.prototype.clearList = function () {
    if ( dvbManager.ClearChannelList() === 0 ) {
        loadChannels();
        instanceList.forEach(function ( item ) { item.emit('channels:update'); });
    }
};


/**
 * Stop scanning.
 */
Provider.prototype.stopScan = function () {
    if ( eventFunction ) {
        stbEvent.removeListener('media', eventFunction);
        eventFunction = null;
    }
    dvbManager.StopChannelScan();
    loadChannels();
    instanceList.forEach(function ( item ) { item.emit('scanning:stop'); });
};


/**
 * Destroy and remove this instance from instance list.
 */
Provider.prototype.destroy = function () {
    var index = instanceList.indexOf(this);

    if ( index !== -1 ) {
        instanceList = instanceList.splice(index, 1);
    }
};


module.exports = {
    onAppInit: function ( config, callback ) {
        var provider = new Provider();

        if ( firstLoad ) {
            init(config);
        }

        instanceList.push(provider);
        callback(null, provider);
    },
    onInit: function ( config, callback ) {
        initData();
        callback();
    },
    onSettingsInit: function ( config, callback ) {
        api = config.api;

        gettextWrapper.load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            gettext = gettextWrapper.gettext;
            callback(null, build());
        });
    }
};
